module.exports = __webpack_public_path__ + "img/hr-programmable-speaker.be84528e.png";